import { Box, Button, Typography } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

interface MenuProps {
  onClick?: React.MouseEventHandler;
}

const BackButton = ({ onClick }: MenuProps) => {
  return (
    <Box display='flex ' alignItems='center' onClick={onClick}>
      <Box
        flex='0 0 6%'
        sx={{
          '& button': {
            p: 0,
            pl: 1,
            minWidth: '24px',
            height: '24px',
            width: '24px',
            alignItem: 'center',
            justifyContent: 'space-between',
            border: 0,
            '& svg': {
              width: '12px',
            },
          },
        }}
      >
        <Button>
          <ArrowBackIosIcon />
        </Button>
      </Box>

      <Box ml={1} flex='0 0 94%'>
        <Typography variant='body2'>Back</Typography>
      </Box>
    </Box>
  );
};

export default BackButton;
